/*
 * @Author: wyh
 * @Date: 2019-06-19 16:00:03
 * @Last Modified by: wyh
 * @Last Modified time: 2019-06-19 17:05:49
 * @Description: http服务拦截器封装桶 用于一次导入app.module
 */
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { AuthInterceptor } from "./auth-interceptor";
import { LogInterceptor } from "./log-interceptor";

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LogInterceptor, multi: true },
];



// WEBPACK FOOTER //
// ./src/services/common/http/index-interceptor.ts